<template>
  <div style="width: 100%">
    <PersonalAreaNavBar
      :title="$t('personalArea.personalInfo')"
      backurl="personal-area-mainmenu"
    />
    <PersonalAreaNoInternet />
    <div
      v-if="firstName || lastName"
      style="padding: 0px 0px 15px 0px"
      class="lang-dir"
      :style="{ 'padding-top': $store.state.hasInternet ? '15px' : '0px' }"
    >
      <PersonalAreaSimpleSidesRow :title="$t('personalArea.fullName')"
        ><b>{{ firstName }} {{ lastName }}</b></PersonalAreaSimpleSidesRow
      >
      <PersonalAreaSimpleSidesRow :title="$t('personalArea.mosad')"
        ><b>{{ institution }}</b></PersonalAreaSimpleSidesRow
      >
      <PersonalAreaSimpleSidesRow
        :title="$t('personalArea.mail')"
        :hideborder="email == ''"
      >
        <div class="miss-mail" v-if="email == ''">
          <Icons icon="pa-warning" height="16px" width="16px" />
          <b>{{ $t("personalArea.miss") }}</b>
        </div>
        <div v-else>
          <b>{{ email }}</b>
        </div>
      </PersonalAreaSimpleSidesRow>
      <div class="miss-mail-container" v-if="email == ''">
        <div class="miss-mail-msg">
          <p>
            <b>{{ $t("personalArea.yourMailMissToUs") }}</b>
          </p>
          <p>
            <template v-if="$store.state.hasInternet">
              {{ $t("personalArea.wePromiseNotPublish") }}
            </template>
            <template v-else>
              {{ $t("personalArea.offlineMailToUpdate") }}
            </template>
          </p>
        </div>
        <div v-if="$store.state.hasInternet">
          <div class="btn" @click="openEditForm">
            <b> {{ $t("personalArea.updateMail") }}</b>
          </div>
        </div>
      </div>
      <PersonalAreaSimpleSidesRow :title="$t('personalArea.country')"
        ><b>{{ land }}</b></PersonalAreaSimpleSidesRow
      >
      <PersonalAreaSimpleSidesRow :title="$t('personalArea.landForUs')"
        ><b>{{ us_country }}</b></PersonalAreaSimpleSidesRow
      >
      <PersonalAreaSimpleSidesRow :title="$t('personalArea.city')"
        ><b>{{ city }}</b></PersonalAreaSimpleSidesRow
      >
      <PersonalAreaSimpleSidesRow :title="$t('personalArea.address')"
        ><b>{{ address }}</b></PersonalAreaSimpleSidesRow
      >
      <!-- <PersonalAreaSimpleSidesRow title="מספר בית"
        ><b>15</b></PersonalAreaSimpleSidesRow
      > -->
      <PersonalAreaSimpleSidesRow :title="$t('personalArea.tel')"
        ><b>{{ phone }}</b></PersonalAreaSimpleSidesRow
      >
      <PersonalAreaSimpleSidesRow
        :title="$t('personalArea.cell')"
        style="border-bottom: 0px"
        ><b>{{ cellPhone }}</b></PersonalAreaSimpleSidesRow
      >
      <!-- <PersonalAreaItemInfo :hideborder="true" rtitle="תוספות והערות"
        ><p style="padding-top: 7px"><b>שרי ישראל</b></p></PersonalAreaItemInfo
      > -->
      <div class="change-info-btn" v-if="$store.state.hasInternet">
        <div @click="openEditForm" class="btn btn-larg">
          <b>{{ $t("personalArea.toUpdateInfo") }}</b>
        </div>
      </div>
      <div class="msg-update-no-internet" v-else>
        <p
          style="
            color: rgba(255, 255, 255, 0.6);
            font-weight: 700;
            font-size: 11px;
          "
        >
          {{ $t("personalArea.didYouChangeInfo") }}
        </p>
        <p style="font-size: 13px">
          {{ $t("personalArea.anotherUpdateByMailMsg") }}
        </p>
        <p style="font-size: 11px">
          {{ $t("personalArea.weUpdateWhenYouHaveInternet") }}
        </p>
      </div>
    </div>
    <div
      v-else
      style="
        padding: 0px 0px 15px 0px;
        color: #7b7b7b;
        font-size: 15px;
        font-style: normal;
        font-weight: 700;
        width: 100%;
        text-align: center;
      "
      class="lang-dir"
      :style="{ 'padding-top': $store.state.hasInternet ? '15px' : '0px' }"
    >
      {{ $t("personalArea.loading") }}
    </div>
  </div>
</template>

<script>
import PersonalAreaSimpleSidesRow from "./PersonalAreaSimpleSidesRow.vue";
import PersonalAreaItemInfo from "./PersonalAreaItemInfo.vue";
import Icons from "@/components/Icons/Icons.vue";
import PersonalAreaNavBar from "./PersonalAreaNavBar.vue";
import menu from "@/services/menu";
import mixPersonalArea from "@/mixing/mixPersonalArea";
import PersonalAreaNoInternet from "./PersonalAreaNoInternet.vue";
export default {
  mixins: [mixPersonalArea],
  components: {
    Icons,
    PersonalAreaSimpleSidesRow,
    PersonalAreaItemInfo,
    PersonalAreaNavBar,
    PersonalAreaNoInternet,
  },
  methods: {
    openEditForm() {
      menu.openAt("personal-area-editform");
    },
  },
};
</script>

<style lang="scss" scoped>
.miss-mail-msg {
  font-size: 11px;
  font-style: normal;
  line-height: 120%;
}
.miss-mail-container * {
  margin: 0px;
}
.miss-mail-container {
  display: flex;
  justify-content: space-between;
  color: #a7610f;

  border-bottom: 1px solid #dedede;
  align-items: center;
  padding: 10px 10px;
  padding-top: 5px;
}
.miss-mail {
  color: rgb(167, 97, 15);
  display: flex;
  align-items: center;
  gap: 5px;
}
.change-info-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
}
.msg-update-no-internet {
  display: flex;
  padding: 10px;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  align-self: stretch;
  border-radius: 5px;
  background-color: var(--custom-color1);
  margin: 15px;
}
.msg-update-no-internet p {
  margin: 0px;
  line-height: 120%;
  color: white;
}
</style>
